import React from 'react';
import { Row, Col, Container, Image } from 'react-bootstrap';
import { Colors } from 'modules/theme';

import { Alerts, Recommendations, Transactions } from 'assets/media/images';

const FinanceComponent = () => (
  <Container fluid className="py-5" style={{ backgroundColor: Colors.greyDark }}>
    <Container className="pb-4" style={{ maxWidth: 720, textAlign: 'center' }}>
      <h4 className="pb-2">Everything you need, all in one place.</h4>
      <h5 style={{ textAlign: 'center', lineHeight: '1.7', color: 'rgba(255,255,255,0.8)' }}>
        Yieldbucks is your personal financial companion — designed to simplify decisions, surface
        insights, and keep you moving toward your goals without the noise.
      </h5>
    </Container>
    <Container>
      <Row className="justify-content-center g-4">
        <Col xs={12} sm={10} md={3} lg={3} className="px-3 pb-4">
          <Container
            fluid
            className="cardHome d-flex flex-column align-items-center justify-content-center"
            style={{ padding: '32px 24px', textAlign: 'center' }}
          >
            <Image src={Recommendations} width="64" style={{ marginBottom: 24 }} />
            <p className="textWhite mb-0" style={{ fontSize: 15, lineHeight: '1.6' }}>
              Personalized guidance tailored to your unique financial profile — always one step
              ahead.
            </p>
          </Container>
        </Col>
        <Col xs={12} sm={10} md={3} lg={3} className="px-3 pb-4">
          <Container
            fluid
            className="cardHome d-flex flex-column align-items-center justify-content-center"
            style={{ padding: '32px 24px', textAlign: 'center' }}
          >
            <Image src={Transactions} width="64" style={{ marginBottom: 24 }} />
            <p className="textWhite mb-0" style={{ fontSize: 15, lineHeight: '1.6' }}>
              A clear, unified view of where you stand — everything visible, nothing overlooked.
            </p>
          </Container>
        </Col>
        <Col xs={12} sm={10} md={3} lg={3} className="px-3 pb-4">
          <Container
            fluid
            className="cardHome d-flex flex-column align-items-center justify-content-center"
            style={{ padding: '32px 24px', textAlign: 'center' }}
          >
            <Image src={Alerts} width="64" style={{ marginBottom: 24 }} />
            <p className="textWhite mb-0" style={{ fontSize: 15, lineHeight: '1.6' }}>
              Intelligent alerts that keep your goals in sight and your limits in check.
            </p>
          </Container>
        </Col>
      </Row>
    </Container>
  </Container>
);

export default FinanceComponent;
